import * as Types from '../../__generated__/api/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type LabelFragment = {
  __typename: 'Label';
  color: string | null;
  text: string;
  textColor: string;
};

export const LabelFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LabelFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Label' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'color' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'textColor' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LabelFragment, unknown>;
